const defaultFont = 'PPNeueMontreal';
const geistFont = 'Geist';
export const caveatFontFamily = 'Caveat';
export const sansFontFamily = [
  defaultFont,
  geistFont,
  'ui-sans-serif',
  'system-ui',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  '"Noto Sans"',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
  '"Noto Color Emoji"',
];
export const serifFontFamily = ['ui-serif', 'Georgia', 'Cambria', '"Times New Roman"', 'Times', 'serif'];
export const fontStyles = {
  px: {
    accent: { fontSize: 60, fontWeight: 700, lineHeight: 72 },
    caption: { fontSize: 12, fontWeight: 500, lineHeight: 18 },
    captionBold: { fontSize: 12, fontWeight: 700, lineHeight: 18 },
    h1: { fontSize: 32, fontWeight: 700, lineHeight: 40 },
    h2: { fontSize: 24, fontWeight: 700, lineHeight: 32 },
    h3: { fontSize: 20, fontWeight: 700, lineHeight: 24 },
    h4: { fontSize: 18, fontWeight: 700, lineHeight: 27 },
    h5: { fontSize: 16, fontWeight: 700, lineHeight: 24 },
    h6: { fontSize: 14, fontWeight: 700, lineHeight: 21 },
    'p-lg': { fontSize: 18, fontWeight: 500, lineHeight: 27 },
    'p-md': { fontSize: 16, fontWeight: 500, lineHeight: 24 },
    'p-sm': { fontSize: 14, fontWeight: 500, lineHeight: 21 },
  },

  rem: {
    accent: {
      fontSize: '3.75rem',
      fontWeight: '700',
      lineHeight: '4.5rem',
    },
    caption: { fontSize: '0.75rem', fontWeight: '500', lineHeight: '1.125rem' },
    captionBold: { fontSize: '0.75rem', fontWeight: '700', lineHeight: '1.125rem' },
    h1: { fontSize: '2rem', fontWeight: '700', lineHeight: '3rem' },
    h2: { fontSize: '1.5rem', fontWeight: '700', lineHeight: '2.25rem' },
    h3: { fontSize: '1.25rem', fontWeight: '700', lineHeight: '1.875rem' },
    h4: { fontSize: '1.125rem', fontWeight: '700', lineHeight: '1.6875rem' },
    h5: { fontSize: '1rem', fontWeight: '700', lineHeight: '1.5rem' },
    h6: { fontSize: '0.875rem', fontWeight: '700', lineHeight: '1.3125rem' },
    'p-lg': { fontSize: '1.125rem', fontWeight: '500', lineHeight: '1.6875rem' },
    'p-md': { fontSize: '1rem', fontWeight: '500', lineHeight: '1.5rem' },
    'p-sm': { fontSize: '0.875rem', fontWeight: '500', lineHeight: '1.3125rem' },
  },
} as const;

export type FontSize = keyof (typeof fontStyles)['px'];
